import { pList } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import rList from '../../../../api/models/rList';
import { rProje } from '../../../../api/models/rProje';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_PROJELISTELE,
    new Api.Veri.ProjeListele().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rList<rProje> | null | undefined,
  error: IError | null | undefined
): IApiAction<rProje[]> =>
  ActionFunctions.action_async_complete_api<rProje[]>(
    ActionSubTypes.API_PROJELISTELE,
    data?.Values,
    error
  );
